import { useActionMutation } from '@ztechapps/common.hook'
import type { CreateOrderPackingSlipDocumentLinkArgs, DocumentLinkCreated } from '@ztechapps/common.contract'
import { createOrderPackingSlipDocumentLinkQuery } from './graphql'

export type UseCreateOrderPackingSlipDocumentLinkResult = {
  /** Creates a new public packing-slip link for the order; the token is shown only in this result. */
  mint: (orderId: string) => Promise<DocumentLinkCreated>
}

export const useCreateOrderPackingSlipDocumentLink = (): UseCreateOrderPackingSlipDocumentLinkResult => {
  const [createLink] = useActionMutation<DocumentLinkCreated, CreateOrderPackingSlipDocumentLinkArgs>({
    query: createOrderPackingSlipDocumentLinkQuery,
  })

  return { mint: (orderId) => createLink({ orderId }) }
}
